import { createDirectus, rest, readItems, readItem, readSingleton, aggregate } from '@directus/sdk'

const BACKEND_BASE_URL = process.env.NEXT_PUBLIC_BACKEND_BASE_URL || 'http://localhost:8055'

const directusClient = createDirectus(BACKEND_BASE_URL).with(
  rest({
    onRequest: options => ({ ...options, next: { revalidate: 60 } }),
  })
)

const getFileUrl = (fileId: string) => {
  return `${BACKEND_BASE_URL}/assets/${fileId}`
}

const localeMap: { [key: string]: string } = {
  ru: 'ru-RU',
  en: 'en-GB',
  zh: 'zh-CN',
  pt: 'pt-BR',
  fr: 'fr-FR',
  ar: 'ar-SA',
  id: 'id-ID',
  fa: 'fa-IR',
}

const langDir: { [key: string]: string } = {
  ar: 'rtl',
  fa: 'rtl',
}

const defaultLocaleShort = 'ru'
const defaultLocaleFull = 'ru-RU'

const fileFields = ['id', 'title', 'description', 'modified_on', 'filename_disk', 'filename_download']

const imageFields = [...fileFields, 'width', 'height']

export {
  directusClient,
  readItems,
  readItem,
  readSingleton,
  aggregate,
  getFileUrl,
  localeMap,
  langDir,
  fileFields,
  imageFields,
  defaultLocaleShort,
  defaultLocaleFull,
}
